var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSellerAskBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#21252A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.504 16.154c.36 0 .608-.19 1.055-.586l2.527-2.249h4.702c2.183 0 3.355-1.208 3.355-3.354v-5.61C17.143 2.207 15.97 1 13.788 1H4.354C2.172 1 1 2.201 1 4.354v5.61c0 2.154 1.172 3.355 3.354 3.355h.352v1.905c0 .564.286.93.798.93zm.3-1.34v-2.125c0-.395-.153-.549-.549-.549h-.9c-1.48 0-2.176-.754-2.176-2.182V4.354c0-1.428.696-2.175 2.175-2.175h9.434c1.472 0 2.175.747 2.175 2.175v5.604c0 1.428-.703 2.182-2.175 2.182H9.042c-.41 0-.615.059-.894.344l-2.343 2.33zM5.49 8.206c.578 0 1.047-.469 1.047-1.047 0-.579-.469-1.048-1.047-1.048-.579 0-1.048.47-1.048 1.048 0 .578.47 1.047 1.048 1.047zm3.589 0c.57 0 1.047-.469 1.047-1.047 0-.579-.476-1.048-1.047-1.048-.579 0-1.055.47-1.055 1.048 0 .578.476 1.047 1.055 1.047zm3.581 0c.579 0 1.048-.469 1.048-1.047 0-.579-.47-1.048-1.048-1.048-.578 0-1.047.47-1.047 1.048 0 .578.469 1.047 1.047 1.047z",
    transform: "translate(-146 -271) translate(0 92) translate(16 53) translate(0 10) translate(0 101) translate(130 14) translate(0 1)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSellerAskBlack);
export default __webpack_public_path__ + "static/media/ic_seller_ask_black.f0d3a01b642f577b456423c4ba90726b.svg";
export { ForwardRef as ReactComponent };